import { gql } from '@apollo/client';

export const DELETE_CAMPAIGN_MESSAGE = gql`
  mutation DeleteCampaignMessage($id: ID!) {
    deleteCampaignMessage(input: { id: $id }) {
      success
      errors
    }
  }
`; 